import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
import { Category } from "../../../@types/Category";
import axiosInstance from "../../../utils/axiosConfig";

export const findFileTypeById = createAsyncThunk(
  "fileTypes/findFileTypeById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${api.baseURL}category/${id}`);
      const data: Category = response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


